import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import { LOGO, SERVICES } from '../constants';
import Style from './StatusSkeleton.module.scss';

type Props = {
  serviceId: ServiceId;
  status: string;
  location: string;
};

const StatusSkeleton: React.FC<Props> = ({ serviceId, status, location }): JSX.Element => {
  return (
    <div className={Style.panel} data-status={status} data-location={location}>
      <div className={Style.top}>
        <span className={Style.icon}>
          <img src={LOGO[serviceId]} className={Style.image} alt="" />
        </span>
        <div className={Style.text}>
          <div className={Style.service}>{SERVICES[serviceId]}</div>
          <span className={Style.label}></span>
        </div>
      </div>
      <div className={Style.bottom}>
        {status === 'error' ? (
          <div className={Style.message}>データ取得に失敗しました</div>
        ) : (
          <div className={Style.message}></div>
        )}
      </div>
    </div>
  );
};

export default StatusSkeleton;
